import React from "react";
import "../styles/Videos.css";
import { FaYoutube } from "react-icons/fa";

const Videos = () => {
  const youtubeVideos = [
    {
      id: "video1",
      title: "ஈவிகேஎஸ்.இளங்கோவன் தொடக்கவிழாச் சிறப்புரை",
      url: "https://www.youtube.com/embed/LFcInn3HNfw",
      thumbnail: "https://img.youtube.com/vi/LFcInn3HNfw/mqdefault.jpg"
    },
    {
      id: "video2",
      title: "புலவர் மா.இராமலிங்கம் / கோவை சதாசிவம் / த.ஸ்டாலின் குணசேகரன்",
      url: "https://www.youtube.com/embed/AbqBuxH7BeE",
      thumbnail: "https://img.youtube.com/vi/AbqBuxH7BeE/mqdefault.jpg"
    },
    {
      id: "video3",
      title:
        "திரு. கே. வைத்தியநாதன் அவர்கள் நூல்களை வெளியிட்டு நிகழ்த்திய சிறப்புரை",
      url: "https://www.youtube.com/embed/359B34MoSsg",
      thumbnail: "https://img.youtube.com/vi/359B34MoSsg/mqdefault.jpg"
    },
    {
      id: "video4",
      title:
        "எழுத்தாளர் பவா செல்லதுரை/ கவிஞர் நெல்லை ஜெயந்தா/ த.ஸ்டாலின் குணசேகரன்",
      url: "https://www.youtube.com/embed/hwFk12IrV6w",
      thumbnail: "https://img.youtube.com/vi/hwFk12IrV6w/mqdefault.jpg"
    },
    {
      id: "video5",
      title: "எழுத்தாளர் இமையம் / எழுத்தாளர் சல்மா / எழுத்தாளர் கா.உதயசங்கர்",
      url: "https://www.youtube.com/embed/ijRapME4W_E",
      thumbnail: "https://img.youtube.com/vi/ijRapME4W_E/mqdefault.jpg"
    },
    {
      id: "video6",
      title:
        "எஸ்.ராஜா / பாரதி பாஸ்கர் / த.ஸ்டாலின் குணசேகரன் / சிந்தனை அரங்கம்",
      url: "https://www.youtube.com/embed/i5yPp5XDTNY",
      thumbnail: "https://img.youtube.com/vi/i5yPp5XDTNY/mqdefault.jpg"
    },
    {
      id: "video7",
      title: "பேராசிரியர் த.இராஜாராம் / கவிஞர் கே.ஜீவபாரதி / சொற்பொழிவுகள்",
      url: "https://www.youtube.com/embed/LALeFu_uibY",
      thumbnail: "https://img.youtube.com/vi/LALeFu_uibY/mqdefault.jpg"
    },
    {
      id: "video8",
      title: "முனைவர் வே.சங்கர நாராயணன் / அறிவின் அறுவடை",
      url: "https://www.youtube.com/embed/7_G2EgUOyHQ",
      thumbnail: "https://img.youtube.com/vi/7_G2EgUOyHQ/mqdefault.jpg"
    },
    {
      id: "video9",
      title: "குன்றக்குடி பொன்னம்பல அடிகளார் / அன்பே தவம் / உரைத்துளி...",
      url: "https://www.youtube.com/embed/j5ZZQqje3kc",
      thumbnail: "https://img.youtube.com/vi/j5ZZQqje3kc/mqdefault.jpg"
    },
    {
      id: "video10",
      title: "கே.இளம்பகவத் ஐஏஎஸ் / உரைத்துளி...",
      url: "https://www.youtube.com/embed/2vArLCPbZe0",
      thumbnail: "https://img.youtube.com/vi/2vArLCPbZe0/mqdefault.jpg"
    },
    {
      id: "video11",
      title: " ஈ.வி.கே.எஸ்.இளங்கோவன் / உரைத்துளி",
      url: "https://www.youtube.com/embed/tRbkTtjjSfs",
      thumbnail: "https://img.youtube.com/vi/tRbkTtjjSfs/mqdefault.jpg"
    },
    {
      id: "video12",
      title: "ஜிடி.நாயுடு விருது / விஞ்ஞானி மு.லட்சுமணன் / உரைத்துளி...",
      url: "https://www.youtube.com/embed/4zdTIHdl10E",
      thumbnail: "https://img.youtube.com/vi/4zdTIHdl10E/mqdefault.jpg"
    },
    {
      id: "video13",
      title: "ஜிடி.நாயுடு விருது / விஞ்ஞானி தி.இராமசாமி / உரைத்துளி...",
      url: "https://www.youtube.com/embed/g9YmcRu-8vw",
      thumbnail: "https://img.youtube.com/vi/g9YmcRu-8vw/mqdefault.jpg"
    },
    {
      id: "video14",
      title: "கதைக்களம் / லெட்சுமி விசாகன் / பள்ளி மாணவர்கள் / குட்டிக் கதைகள்",
      url: "https://www.youtube.com/embed/h13MaJW6z4E",
      thumbnail: "https://img.youtube.com/vi/h13MaJW6z4E/mqdefault.jpg"
    },
    {
      id: "video15",
      title:
        "ஊடகவியலாளர் க.கார்த்திகேயன் / நான் ஏன் வாசிக்கிறேன்? / உரைத்துளி...",
      url: "https://www.youtube.com/embed/HlFETDzErgQ",
      thumbnail: "https://img.youtube.com/vi/HlFETDzErgQ/mqdefault.jpg"
    },
    {
      id: "video16",
      title: " டாக்டர் ஏ.சிவதாணு பிள்ளை - நிறைவுரை",
      url: "https://www.youtube.com/embed/EDPjpK1GjRI",
      thumbnail: "https://img.youtube.com/vi/EDPjpK1GjRI/mqdefault.jpg"
    },
    {
      id: "video17",
      title:
        "பேராசிரியர் ஜெயந்தஸ்ரீ பாலகிருஷ்ணன் - பார்வைகளும் தரிசனங்களும் - உரைத்துளி",
      url: "https://www.youtube.com/embed/k_DaYUpdWro",
      thumbnail: "https://img.youtube.com/vi/k_DaYUpdWro/mqdefault.jpg"
    },
    {
      id: "video18",
      title: "டி.கே.எஸ்.கலைவாணன் - நாடகமும் தமிழிசையும்",
      url: "https://www.youtube.com/embed/SnBlMMiXE-c",
      thumbnail: "https://img.youtube.com/vi/SnBlMMiXE-c/mqdefault.jpg"
    }
  ];
  return (
    <section className="youtube-section">
      <div className="section-header">
        <FaYoutube className="youtube-icon" />
        <h2>புத்தகத் திருவிழா வீடியோக்கள்</h2>
      </div>
      <p className="section-description">
        கடந்த ஆண்டுகளில் நடைபெற்ற புத்தகத் திருவிழாக்களின் சிறப்பு நிகழ்ச்சிகள்
      </p>

      <div className="youtube-container">
        {youtubeVideos.map((video) => (
          <div key={video.id} className="video-card">
            <div className="video-wrapper">
              <iframe
                src={`${video.url}?rel=0`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h3 className="video-title">{video.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Videos;
